import http from './http'

export default {
  smsCode: {
    sendSMSCode (phone, type = 0) {
      return http.post('/basis/smscode/send', {phone: phone, type: type})
    },
    validSMSCode (phone, code) {
      return http.post('/basis/smscode/validcode', {phone: phone, code: code})
    }
  },
  qiniu: {
    getUploadParams () {
      return http.get('/basis/qiniu/getuploadparams')
    },
    getDownloadPrivateUrls (keys) {
      return http.post('/basis/qiniu/getdownloadprivateurls', keys)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/basis.js